import React from 'react';
import PreviewPanel from './PreviewPanel';
import { PreviewProvider } from './PreviewContext';

/**
 * Standalone preview window component
 * Opens in a separate browser window for multi-monitor setups
 */
const PreviewPopup = () => {
  return (
    <PreviewProvider>
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#0f172a',
        padding: '1rem',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '1rem',
          padding: '0.75rem 1rem',
          backgroundColor: '#1e293b',
          borderRadius: '0.75rem',
          border: '1px solid #334155',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#22c55e' }} />
            <span style={{ color: '#64748b', fontSize: '12px', fontWeight: 500 }}>
              Live Preview - Separate Window
            </span>
          </div>
          <button
            onClick={() => window.close()}
            style={{
              padding: '0.25rem 0.75rem',
              backgroundColor: '#334155',
              color: '#94a3b8',
              border: 'none',
              borderRadius: '0.375rem',
              fontSize: '12px',
              cursor: 'pointer',
            }}
          >
            Close
          </button>
        </div>

        {/* Preview Content */}
        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '0.75rem',
          overflow: 'hidden',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
          minHeight: 'calc(100vh - 6rem)',
        }}>
          <PreviewPanel />
        </div>
      </div>
    </PreviewProvider>
  );
};

export default PreviewPopup;
